export const normalizeStatusValue = (value) => {
  if (typeof value !== "string") return "";
  return value.trim().toLowerCase();
};

export const normalizeLeaveTypeValue = (value) => {
  if (typeof value !== "string") return "";
  return value.trim().toLowerCase();
};

// Infinity codes are stored as strings in the database and are not
// guaranteed to be numeric (they can carry prefixes or leading zeros).
// Use this whenever the code is sent to the API — coercing to a Number
// mangles non-numeric codes and drops leading zeros, so the backend
// match silently fails.
export const normalizeInfinityCodeString = (value) => {
  if (value === undefined || value === null) return null;
  const trimmed = String(value).trim();
  return trimmed.length > 0 ? trimmed : null;
};

export const normalizeInfinityCodeValue = (value) => {
  if (value === undefined || value === null) return null;
  const trimmed = String(value).trim();
  if (!trimmed) return null;
  const direct = Number(trimmed);
  if (Number.isFinite(direct)) return direct;
  const digitsOnly = trimmed.replace(/[^0-9-]+/g, "");
  if (!digitsOnly) return null;
  const fallback = Number(digitsOnly);
  return Number.isFinite(fallback) ? fallback : null;
};